// représente un onglet de menu de
export interface IMenuTab {
	id: string;
	title: string;
	items: IMenuTabItem[];
}

// Représente un élément du menu
export interface IMenuTabItem {
	id: string;
	idParent: string;
	text: string;
	longText: string;
	action: MenuActionEnum;
	target: string;
	imgCode: string;
	img: string;
	children: IMenuTabItem[];
}

// 
export enum MenuActionEnum {
	noAction = 0,
	link = 1,
	submenu = 2,
	widget = 3,
}
